import styled, { css } from 'styled-components'

import { transparentize } from 'ui/themes/utils'

import BPeriod from '../../blocks/Period'

export const DateTimeContainer = styled.div`
  &:first-child {
    border-radius: 3px 3px 0 3px;
  }

  &:nth-child(2) {
    border-radius: 3px 3px 3px 0;
  }

  ${(props) => props.disabled || (props.active ?
    css`
      margin-bottom: -2px !important;

      border-bottom: 2px solid !important;
      ${(props) => props.brandingColor ? `border-color: ${props.brandingColor} !important` : ''};
    ` :
    css`
      &:hover {
        margin-bottom: -2px !important;

        border-bottom: 2px solid !important;

        ${(props) => props.brandingColor ? `border-color: ${transparentize(props.brandingColor, 0.5)} !important` : ''};
      }
    `)}
`

export const Container = styled.div`
  position: relative;

  display: flex;

  ${(props) => props.useAMPM ? 'min-width: 330px' : 'min-width: 270px'};

  width: 100%;
  min-height: 50px;

  background: #FFFFFF;

  border: 1px solid #E9EBED !important;
  border-radius: 3px;

  ${DateTimeContainer} {
    width: 100%;

    &:first-of-type ${BPeriod.Detail} {
      border-right: 1px solid #E9EBED !important;
    }

    ${BPeriod.Detail} {
      display: flex;
      flex-flow: column nowrap;
      justify-content: center;

      padding: 10px;

      width: 100%;
      height: 100%;

      cursor: pointer;
    }
  }

  @media screen and (max-width: 320px) {
    display: block;
    min-width: 100%;

    ${DateTimeContainer} {
      &:first-child {
        border-bottom: 1px solid #E9EBED !important;
      }
    }
}
`

export const Label = styled.div`
  margin: 4px 0 !important;

  font-weight: 500 !important;
`
